if (!customElements.get("m-ask-question")) {
  customElements.define(
    "m-ask-question",
    class MAskQuestion extends HTMLElement {
      constructor() {
        super()
        this.selectors = {
          openButton: '[data-open-ask-question]',
          content: '.m-form-ask-question',
          container: '.m-product-addon',
          formSuccess: '.form-ask__success'
        }
      }

      connectedCallback() {
        this.domNodes = queryDomNodes(this.selectors, this);
        this.container = document.querySelector(this.selectors.container);
        this.colorScheme = this.domNodes.content.dataset.colorScheme;
        if (this.domNodes.content && this.domNodes.content.innerHTML) {
          this.content = this.domNodes.content.innerHTML;
          this.init();
        }
      }

      init() {
  this.showSuccessMessage();
  this.modal = new MinimogTheme.Modal();
  addEventDelegate({
    selector: this.selectors.openButton,
    handler: (e) => {
      e.preventDefault()
      if (this.content) {
        const html = document.createElement("DIV");
        html.innerHTML = this.content;
        this.modal.appendChild(html);
        this.modal.setWidth('500px');
        this.modal.setSizes(`m-form-ask-question m-gradient ${this.colorScheme}`);
        this.container.classList.remove('m\:hidden');
        this.bindAjaxSubmit(html);
        this.modal.open();
      }
    }
  })
}

      // Invia il form via fetch invece di una submit normale: niente cambio pagina
      bindAjaxSubmit(scope) {
        const form = scope.querySelector('form');
        if (!form) return;

        const submitBtn = form.querySelector('[type="submit"]');
        const wrapper = form.querySelector('.m-form-ask-question__wrapper');

        form.addEventListener('submit', (e) => {
          e.preventDefault();

          if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.dataset.originalText = submitBtn.dataset.originalText || submitBtn.textContent;
            submitBtn.textContent = 'Sending...';
          }

          const formData = new FormData(form);

          fetch(form.getAttribute('action') || '/contact', {
            method: 'POST',
            body: formData
          })
            .then((res) => res.text())
            .then((responseHtml) => {
              const doc = new DOMParser().parseFromString(responseHtml, 'text/html');
              const success = doc.querySelector('.form-ask__success');

              if (success) {
                if (wrapper) wrapper.style.display = 'none';
                form.reset();
                MinimogTheme.Notification.show({
                  target: document.body,
                  method: 'appendChild',
                  type: 'success',
                  message: success.dataset.message,
                  delay: 2000,
                  sticky: true
                });
                setTimeout(() => { this.modal.close(); }, 1200);
              } else {
                MinimogTheme.Notification.show({
                  target: document.body,
                  method: 'appendChild',
                  type: 'error',
                  message: 'Please check the form and try again.',
                  delay: 3000,
                  sticky: true
                });
              }
            })
            .catch(() => {
              MinimogTheme.Notification.show({
                target: document.body,
                method: 'appendChild',
                type: 'error',
                message: 'Something went wrong. Please try again.',
                delay: 3000,
                sticky: true
              });
            })
            .finally(() => {
              if (submitBtn) {
                submitBtn.disabled = false;
                submitBtn.textContent = submitBtn.dataset.originalText;
              }
            });
        });
      }

      showSuccessMessage() {
        const successMessage = this.container.querySelector(this.selectors.formSuccess);
        if (successMessage) {
          MinimogTheme.Notification.show({
            target: document.body,
            method: 'appendChild',
            type: 'success',
            message: successMessage.dataset.message,
            delay: 2000,
            sticky: true
          })

          setTimeout(() => {
            const url = window.location.origin + window.location.pathname
            window.history.replaceState({}, document.title, url)
          }, 2500)
        }
      }
    }
  );
}